exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-picker {\n  padding: 1px 0;\n}\n.vux-loadmore.weui-loadmore_line {\n  margin-bottom: 0.6em;\n}\n", ""]);

// exports
